import styled, { css } from 'styled-components';

export default styled.div<{ size?: number }>`
	margin: 0 auto;
	position: relative;
	box-sizing: border-box;
	${({ size = 56 }) => css`
		width: ${size}px;
		height: ${size}px;

		:before {
			border: ${size / 5.6}px solid var(--gray-200);
		}

		:after {
			top: -${size / 5.6}px;
			left: -${size / 5.6}px;
			border: ${size / 5.6}px solid transparent;
		}
	`}

	:before, :after {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		border-radius: 50%;
	}

	:after {
		border-left-color: var(--gray-500);
		animation: 2s linear infinite spin;
	}

	@keyframes spin {
		0% {
			transform: rotate(0deg);
		}

		100% {
			transform: rotate(360deg);
		}
	}
`;
